var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6911 15.3167L13.321 20.6506C12.8855 21.1223 12.1599 21.1223 11.7245 20.6506C11.289 20.2151 11.289 19.4895 11.7245 19.0541L16.2963 14.5183L11.7245 9.94647C11.289 9.51103 11.289 8.7854 11.7245 8.34996C12.1599 7.91451 12.8855 7.91451 13.321 8.34996L18.6911 13.6839C19.1265 14.1556 19.1265 14.845 18.6911 15.3167ZM2 14.5183C2 17.9654 3.41513 21.0857 5.66473 23.3353C7.91433 25.6211 11.0348 27 14.5183 27C17.9654 27 21.0857 25.6211 23.3353 23.3353C25.6211 21.0857 27 17.9652 27 14.5183C27 11.035 25.6211 7.91429 23.3353 5.66473C21.0857 3.41513 17.9652 2 14.5183 2C11.035 2 7.91429 3.41513 5.66473 5.66473C3.41518 7.91433 2 11.0348 2 14.5183Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/Next.06f2fd1ec002d9239c46657fb6a44b45.svg";
export { ForwardRef as ReactComponent };